import styled from '@emotion/styled';

import { pageContentWidth, pageSectionLayout } from '@/styles/pageLayout';

export { PageActionRow as ButtonBox } from '@/components/common/form/formPageStyles';

export const ConferenceContainer = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 4rem;
`;
export const ContentTabList = styled.div`
	${pageContentWidth}
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	text-align: center;
`;
export const ConferenceToolBar = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	&.mobile {
		justify-content: flex-end;
	}
`;
export const ConferenceSearchBox = styled.div`
	display: flex;
	gap: 0.4rem;
	justify-content: flex-end;
	width: 100%;
	height: 4.4rem;
`;
export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 2.4rem;
	flex: 1;
	width: 100%;
`;
export const ConferenceGalleryBox = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 2rem;
	width: 100%;
	@media screen and (max-width: ${(props) => props.theme.scale.contentBreakpoint}) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media screen and (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
export const GalleryItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-width: 0;
	cursor: pointer;
	.img_box {
		width: 100%;
		height: 22rem;
		border-radius: ${(props) => props.theme.effects.radiusMd};
		overflow: hidden;
		box-shadow: ${(props) => props.theme.effects.shadowSm};
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform ${(props) => props.theme.effects.transitionBase};
		}
	}

	&:hover .img_box img {
		transform: scale(1.03);
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	.title {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: ${(props) => props.theme.ui.lineHeight.heading};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		color: #212529;
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.date {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: ${(props) => props.theme.lineHeight.tight};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		color: #868e96;
	}
`;
export const ConferenceGalleryImgBox = styled.div`
	height: 22rem;
`;
export const NoData = styled.p`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 20rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
`;
